import React, { type JSX } from "react";

import { cn } from "utils/helpers/cn";

export type TypoBaseType = {
    className?: string;
    color?: "text-font-1" | "text-font-2" | "text-font-3" | "text-font-4" | "text-f-primary";
    children: React.ReactNode;
    id?: string;
};

interface TypoType extends TypoBaseType {
    classTailwind: string;
    tag: keyof JSX.IntrinsicElements;
}

export function Typo({ className, classTailwind, color = "text-font-1", tag, children, id }: TypoType) {
    const classMerged = cn(classTailwind, color, className);
    return React.createElement(tag, { className: classMerged, id }, children);
}

export function TypoTitle({ className, color = "text-font-1", children, id }: TypoBaseType) {
    return (
        <Typo
            tag="h1"
            classTailwind="scroll-m-20 text-2xl leading-6 font-semibold first:mt-0"
            className={className}
            color={color}
            id={id}
        >
            {children}
        </Typo>
    );
}

export function TypoHeader({ className, color = "text-font-1", children, id }: TypoBaseType) {
    return (
        <Typo
            tag="h2"
            classTailwind="scroll-m-20 text-base leading-6 font-semibold first:mt-0"
            className={className}
            color={color}
            id={id}
        >
            {children}
        </Typo>
    );
}

export function TypoText({ className, color = "text-font-1", children, id }: TypoBaseType) {
    return (
        <Typo
            tag="p"
            classTailwind="scroll-m-20 text-sm leading-6 font-normal first:mt-0"
            className={className}
            color={color}
            id={id}
        >
            {children}
        </Typo>
    );
}

export function TypoTextBold({ className, color = "text-font-1", children, id }: TypoBaseType) {
    return (
        <Typo
            tag="p"
            classTailwind="scroll-m-20 text-sm leading-6 font-semibold first:mt-0"
            className={className}
            color={color}
            id={id}
        >
            {children}
        </Typo>
    );
}

export function TypoTextSmall({ children, className, color = "text-font-1", id }: TypoBaseType) {
    return (
        <Typo
            tag="small"
            classTailwind="scroll-m-20 text-xs leading-5 font-normal first:mt-0"
            className={className}
            color={color}
            id={id}
        >
            {children}
        </Typo>
    );
}
